export default __webpack_public_path__ + "static/media/63.cb220446.jpeg";